// ** React Imports
import { useTranslation } from "react-i18next";
import { useContext } from "react";

// ** Custom Components
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";
import Block from "components/layout/Block";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const PeriodSelector = ({
	periodItems,
	periodSelected,
	periodSetSelected,
	yearItems,
	yearSelected,
	yearSetSelected,
}) => {
	const { t } = useTranslation(["filtersAndSelectors"]);
	const { isPhone } = useContext(deviceTypeContext);

	// #####################################################

	return (
		<Block flex>
			{periodSelected && (
				<SelectorSelectSingle
					label={t("filtersAndSelectors:periodLabel")}
					emptyText={t("common:any.2")}
					items={periodItems}
					selected={periodSelected}
					onAccept={(value) => {
						if (value) {
							periodSetSelected(value);
						} else {
							periodSetSelected({
								value: null,
							});
						}
					}}
					activatorStyle={{
						borderTopRightRadius: "0px",
						borderBottomRightRadius: "0px",
						borderRightColor: "transparent",
					}}
					activatorWrapperStyle={{
						marginRight: "0px",
						minWidth: isPhone ? "150px" : "250px",
						maxWidth: !isPhone && "max-content",
					}}
					activatorStyleOptions={{
						flex1: true,
						noPad: true,
					}}
					withMobileVersion
					customLayerStyle={{
						overflowY: "auto",
					}}
					withFullItem
				/>
			)}

			<SelectorSelectSingle
				label={t("filtersAndSelectors:yearLabel")}
				emptyText={t("common:any.2")}
				items={yearItems}
				selected={yearSelected}
				onAccept={(value) => {
					yearSetSelected(value);
				}}
				activatorStyle={
					periodSelected && {
						borderTopLeftRadius: "0px",
						borderBottomLeftRadius: "0px",
					}
				}
				activatorWrapperStyle={
					periodSelected
						? {
								minWidth: isPhone ? "85px" : "157px",
								width: isPhone ? "auto" : "max-content",
						  }
						: {
								minWidth: isPhone ? "200px" : "407px",
						  }
				}
				activatorStyleOptions={{
					flex1: true,
				}}
				withMobileVersion
			/>
		</Block>
	);
};

export default PeriodSelector;
